import { render, staticRenderFns } from "./FormHotAlert.vue?vue&type=template&id=7ae5938c&"
import script from "./FormHotAlert.vue?vue&type=script&lang=js&"
export * from "./FormHotAlert.vue?vue&type=script&lang=js&"
import style0 from "./FormHotAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports